import { createContext } from 'react';
import Client from '@lt/api';

export type ApiContextState = {
  api: undefined | Client;
};

/**
 * Контекст с параметрами вызова виджета
 */
export const apiContext = createContext<ApiContextState>({ api: undefined });
